import { produce } from 'immer';
import {
  SET_SEARCH_PENDING,
  SET_SEARCH_PARAM,
  SET_SUB_TABLE_QUERY_PENDING,
} from 'store/constants/action-types';

const initialState = {
  searchParam: '',
  pending: false,
  nestedTable: {
    pending: false,
    currentPT: null,
  },
};

export const searchReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case SET_SEARCH_PENDING:
        draft.pending = action.payload;
        break;
      case SET_SEARCH_PARAM:
        draft.searchParam = action.payload;
        break;
      case SET_SUB_TABLE_QUERY_PENDING:
        draft.nestedTable.pending = action.payload.pending;
        draft.nestedTable.currentPT = action.payload.id;
        break;
      default:
        return state;
    }
  });

export default searchReducer;
